import { createStore } from "vuex";
import countriesData from "@/static/countries.json";
const coordinatesFromCountry = countryName => {
  const country = countriesData.find(country => {
    return country.name === countryName;
  });
  const lat = country.latlng[0];
  const lng = country.latlng[1];
  return {
    lat: lat,
    lng: lng
  };
};

export default createStore({
  state: {
    hexBinPoints: []
  },
  mutations: {
    addHexBinPoint(state, { lat, lng }) {
      state.hexBinPoints.push({
        lat: lat,
        lng: lng
      });
    }
  },
  actions: {
    addHexBinPoint({ commit }, coordinates) {
      setTimeout(() => {
        commit("addHexBinPoint", coordinates);
      }, 0);
    },
    addHexBinPointFromCountry({ dispatch }, countryName) {
      dispatch("addHexBinPoint", coordinatesFromCountry(countryName));
    }
  },
  modules: {}
});
